<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="large-panel" style="min-height: 90vh;margin-top: -45vh;height: auto" @click.stop>
                <div v-if="confirmPurchase" class="dialog-body-confirm">
                    <div class="dialog-title">
                        <span v-t="'message.title_purchase_license_confirm'"></span>
                        <span v-if="contractChangeOperation != null" class="contract-change-notice">{{ getContractChangeNotice() }}</span>
                    </div>
                    <hr class="dialog-hr">
                    <div id="dialog-body" :class="[ isNeedExpandBody() ? 'dialog-body-year': '' ,'dialog-body' ]">
                        <div v-if="contractInfo.planType == 0">
                            <confirmlicense :appData="appData"
                                            :licenseInfo="inputForm.license"
                                            :purchasePeriodType="contractInfo.purchasePeriodType"
                                            :confirmType=1
                                            :disablePurchasingOption="disablePurchasingOption"
                                            :currencyYen="currencyYen">
                            </confirmlicense>
                        </div>
                        <div v-else>
                            <ConfirmLicenseForPlanPurchasing :appData="appData"
                                            :licenseInfo="inputForm.license.numberLicense[0]"
                                            :purchasePeriodType="contractInfo.purchasePeriodType"
                                            :confirmType=1
                                            :planType="contractInfo.planType"
                                            :newPlanType="contractInfo.planType"
                                            :priceOfPlan="priceOfPlan"
                                            :priceNewPlan="priceOfPlan"
                                            :currencyYen="currencyYen">
                            </ConfirmLicenseForPlanPurchasing>
                        </div>
                    </div>
                    <hr class="dialog-hr">
                    <div v-if="isPurchasePeriodMonthly(contractInfo.purchasePeriodType)" class="license-item-value" style="text-align: center">
                        <table width="100%">
                            <tr>
                                <td width="50%">
                                    <span v-t="'message.item_purchase_current_amount'"/>
                                    <span class="total-amount">{{ getDisplayAmountValue(getCurrentAmountTotal()) }}</span>
                                    <span v-if="currencyYen" v-t="'message.unit_currency2'"/>
                                    <span v-else>USD</span>
                                </td>
                                <td width="50%">
                                    <span  v-t="'message.item_purchase_next_amount'"/>
                                    <span class="total-amount">{{ getDisplayAmountValue(getNewAmountTotal()) }}</span>
                                    <span v-if="currencyYen" v-t="'message.unit_currency2'"/>
                                    <span v-else>USD</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div v-else>
                        <table width="100%">
                            <tr>
                                <td width="50%">
                                    <el-collapse-transition>
                                        <div v-if="getPurchaseAmountTotal() > 0" class="contract-term">
                                            <span v-t="'message.item_purchase_additional_term'"/>
                                            <span class="term-date">{{ getContractTermString() }}</span>
                                        </div>
                                    </el-collapse-transition>
                                    <div class="purchase-amount">
                                        <span v-t="'message.item_purchase_additional_amount'"/>
                                        <span class="total-amount">{{ getDisplayAmountValue(getPurchaseAmountTotal()) }}</span>
                                        <span  v-t="'message.unit_currency'"/>
                                    </div>
                                </td>
                                <td width="50%">
                                    <el-collapse-transition>
                                        <div v-if="getPurchaseAmountTotal() > 0" class="contract-term">
                                            <span v-t="'message.item_next_contract_term'"/>
                                            <span class="term-date">{{ getNextContractTermString() }}</span>
                                        </div>
                                    </el-collapse-transition>
                                    <div class="purchase-amount">
                                        <span v-t="'message.item_purchase_next_amount'"/>
                                        <span class="total-amount">{{ getDisplayAmountValue(getNewAmountTotal()) }}</span>
                                        <span v-if="currencyYen" v-t="'message.unit_currency2'"/>
                                        <span v-else>USD</span>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="confirmPurchase=false" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" @click="purchaseLicense()" :disabled="disableButton">
                            <span v-if="getPurchaseAmountTotal() == 0">OK
                            </span>
                            <span v-else v-t="'message.button_purchase'">
                            </span>
                        </el-button>
                    </div>
                </div>
                <div v-else>
                    <div class="dialog-title">
                        <span v-t="{ path: 'message.title_purchase_change', args: { contractType: getPurchasePeriodTypeName(contractInfo.purchasePeriodType) } }"></span>
                        <span v-if="contractChangeOperation != null" class="contract-change-notice">{{ getContractChangeNotice() }}</span>
                    </div>
                    <hr class="dialog-hr">
                    <div  id="dialog-body" :class="[ isNeedExpandBody() ? 'dialog-body-year': '' ,'dialog-body' ]">
                        <el-form :model="inputForm" ref="inputForm" label-width="220px" class="inputform">
                            <div class="dialog-form-item">
                                <div class="dialog-description">
                                    <div v-if="isPurchasePeriodMonthly(contractInfo.purchasePeriodType)" v-t="'message.hint_purchase_note_monthly2'">
                                    </div>
                                    <div v-else v-html="$t('message.hint_purchase_note_yearly2')">
                                    </div>
                                    <span v-if="isActiveContract(contractInfo.state)" style="color: #d55169;" v-t="'message.hint_purchase_note1'"></span><br>
                                    <span v-else style="color: #d55169;" v-t="'message.hint_purchase_note2'"><br>
                                    </span>
                                    <a href="javascript:void(0);" style="text-decoration:none" @click="$emit('edituser')" >
                                       <span v-t="'message.info_guide_to_delete_user'"/>
                                    </a>
                                </div>
                                <table v-if="contractInfo.planType == 0" width="100%">
                                    <tr class="license-record-header">
                                        <td class="license-item-title" style="width: 30%" v-t="'message.item_license_basic'">
                                        </td>
                                        <td class="license-item-title" style="text-align:right;width: 20%;padding-right:25px" v-t="'message.item_purchase_current'">
                                        </td>
                                        <td class="license-item-title" style="text-align: right;width: 200px" v-t="'message.item_purchase_change'">
                                        </td>
                                        <td colspan="2" class="license-item-title" style="text-align: right;width: 15%;padding-right:10px" v-t="'message.item_purchase_renewal_amount'">
                                        </td>
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" class="license-item-title" style="text-align: right;width: 15%;padding-right:10px;" v-t="'message.item_purchase_additional_amount'">
                                        </td>
                                    </tr>
                                    <tr v-for="(license , index) in inputForm.license.numberLicense" :class="{'license-record': (index<inputForm.license.numberLicense.length-1),'license-record-bottom': (index==inputForm.license.numberLicense.length-1) }">
                                        <td v-if="license.type < 7" class="license-item-value">
                                            {{ license.displayName}}
                                        </td>
                                        <td v-if="license.type < 7" class="license-item-value" style="text-align: right;padding-right:25px">
                                            {{ Number(license.pastMax).toLocaleString() }}
                                        </td>
                                        <td v-if="license.type == 1" class="license-item-value" style="text-align: right">
                                            <el-input-number v-model="license.newValue" :min="license.current" @change="changeNumberLicense(index)"></el-input-number>
                                        </td>
                                        <td v-else-if="license.type == 2" class="license-item-value" style="text-align: right">
                                            <el-input-number v-model="license.newValue" :min="license.current" :max="inputForm.license.numberLicense[0].newValue" :disabled=license.disabled @change="changeNumberLicense(index)"></el-input-number>
                                        </td>
                                        <td v-else-if="license.type == 3" class="license-item-value" style="text-align: right">
                                            <el-input-number v-model="license.newValue" :min="license.current" :max="inputForm.license.numberLicense[1].newValue" :disabled=license.disabled @change="changeNumberLicense(index)"></el-input-number>
                                        </td>
                                        <td v-else-if="license.type == 4" class="license-item-value" style="text-align: right">
                                            <el-input-number v-model="license.newValue" :min="license.current" :max="inputForm.license.numberLicense[0].newValue" :step="inputForm.license.numberLicense[0].newValue" :disabled=license.disabled @change="changeNumberLicense(index)"></el-input-number>
                                        </td>
                                        <td v-else-if="license.type == 5" class="license-item-value" style="text-align: right">
                                            <el-input-number v-model="license.newValue" :min="0" :max="1" :step=license.unit :disabled=license.disabled @change="changeNumberLicense(index)"></el-input-number>
                                        </td>
                                        <td colspan="2" v-if="license.type < 7" class="license-item-value" style="text-align: right;padding-right:10px">
                                            {{ getDisplayAmountValue(Number(license.newAmount)) }}
                                        </td>
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType) && license.type < 7" class="license-item-value" style="text-align: right;padding-right:10px">
                                            {{ getDisplayAmountValue(Number(license.purchaseAmount)) }}
                                        </td>
                                    </tr>
                                    <hr class="transparent-hr">
                                    <tr class="license-record-header">
                                        <td class="license-item-title" style="width: 30%" v-t="'message.item_license_recurring'">
                                        </td>
                                        <td class="license-item-title" style="text-align:right;width: 20%;padding-right:25px" v-t="'message.item_purchase_current'">
                                        </td>
                                        <td class="license-item-title" style="text-align: right" v-t="'message.item_purchase_next_change'">
                                        </td>
                                        <td class="license-item-title" style="text-align: right;width:13%">
                                        </td>
                                        <td class="license-item-title" style="text-align: right;width: 15%;padding-right:9px" v-t="'message.item_purchase_renewal_amount'">
                                        </td>
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" class="license-item-title" style="text-align: right;width: 15%;padding-right:10px;" v-t="'message.item_purchase_additional_amount'">
                                        </td>
                                    </tr>
                                    <tr class="license-record-header">
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" colspan="6"  class="license-item-note" v-t="'message.hint_purchase_recurring_note1'"></td>
                                        <td v-else colspan="5" class="license-item-note" v-t="'message.hint_purchase_recurring_note1'"></td>
                                    </tr>
                                    <tr v-for="(license , index) in inputForm.license.usageLicense" :class="{'license-record': (index<inputForm.license.usageLicense.length-1),'license-record-bottom': (index==inputForm.license.usageLicense.length-1)}">
                                        <td class="license-item-value">
                                            {{ license.displayName}}
                                            <el-tooltip effect="dark" placement="right">
                                                <div v-if="license.type==100" slot="content" style="text-align:left" v-html="$t('message.hint_purchase_recurring_stt')"></div>
                                                <div v-else-if="license.type==101" slot="content" style="text-align:left" v-html="$t('message.hint_purchase_recurring_translate')"></div>
                                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td class="license-item-value" style="text-align: right;padding-right:25px">
                                            {{ license.current / license.unit }}({{ Number(license.current).toLocaleString()  + getUnitName(license.type) }})
                                        </td>
                                        <td class="license-item-value" style="text-align: right">
                                            <el-input-number v-model="license.newCount" :min="0" :disabled="license.disabled" @change="changeUsageLicense(index)"></el-input-number>
                                        </td>
                                        <td class="license-item-value" style="text-align: left;padding-left:10px">
                                            ({{ Number(license.newValue).toLocaleString()  }} {{ getUnitName(license.type) }})
                                        </td>
                                        <td class="license-item-value" style="text-align: right;padding-right: 10px">
                                             {{ getDisplayAmountValue(Number(license.newAmount)) }}
                                        </td>
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" class="license-item-value" style="width: 80px;padding-right: 10px;text-align: right;">
                                                －
                                        </td>
                                    </tr>
                                    <hr class="transparent-hr">
                                    <tr class="license-record-header">
                                        <td class="license-item-title" style="width: 30%" v-t="'message.item_license_charge'">
                                        </td>
                                        <td class="license-item-title" style="text-align:right;width: 20%;padding-right:25px" v-t="'message.item_purchase_current'">
                                        </td>
                                        <td class="license-item-title" style="text-align: right" v-t="'message.item_purchase_add'">
                                        </td>
                                        <td class="license-item-title" style="text-align: right">
                                        </td>
                                        <td class="license-item-title" style="text-align: right;width: 15%;padding-right:10px" v-t="'message.item_purchase_renewal_amount'">
                                        </td>
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" class="license-item-title" style="text-align: right;width: 15%;padding-right:10px;" v-t="'message.item_purchase_additional_amount'">
                                        </td>
                                    </tr>
                                    <tr class="license-record-header">
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" colspan="6" class="license-item-note" v-t="'message.hint_purchase_charge_note1'"></td>
                                        <td v-else colspan="5" class="license-item-note" v-t="'message.hint_purchase_charge_note1'"></td>
                                    </tr>
                                    <tr v-for="(license , index) in inputForm.license.chargedLicense" :class="{'license-record': (index<inputForm.license.chargedLicense.length-1),'license-record-bottom': (index==inputForm.license.chargedLicense.length-1)}">
                                        <td class="license-item-value">
                                            {{ license.displayName}}
                                            <el-tooltip effect="dark" placement="right">
                                                <div v-if="license.type==200" slot="content" style="text-align:left" v-html="$t('message.hint_purchase_charge_stt')"></div>
                                                <div v-else-if="license.type==201" slot="content" style="text-align:left" v-html="$t('message.hint_purchase_charge_translate')"></div>
                                                <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                            </el-tooltip>
                                        </td>
                                        <td class="license-item-value" style="text-align: right;padding-right:25px">
                                            {{ (license.orgValue)/license.unit }}({{ Number(license.orgValue).toLocaleString() + getUnitName(license.type) }})
                                        </td>
                                        <td class="license-item-value" style="text-align: right;">
                                            <el-input-number v-model="license.newCount" :min="0" :disabled="license.disabled" @change="changeChargedLicense(index)"></el-input-number>
                                        </td>
                                        <td class="license-item-value" style="text-align: left;padding-left:9px">
                                            ({{ Number(license.newValue).toLocaleString()  }} {{ getUnitName(license.type) }})
                                        </td>
                                        <td class="license-item-value" style="text-align: right;padding-right: 10px">
                                            －
                                        </td>
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" class="license-item-value" style="text-align: right;width: 80px ;padding-right: 10px">
                                            {{ getDisplayAmountValue(Number(license.purchaseAmount)) }}
                                        </td>
                                    </tr>
                                    <hr class="transparent-hr">
                                    <!---tr>
                                        <td class="license-item-value">
                                            合計
                                        </td>
                                        <td class="license-item-value"></td>
                                        <td class="license-item-value"></td>
                                        <td class="license-item-value" style="text-align: right;padding-right:10px">
                                            {{ getDisplayAmountValue(getNewAmountTotal()) }}
                                        </td>
                                        <td  v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" class="license-item-value" style="text-align: right;padding-right:10px">
                                            {{ getDisplayAmountValue(getPurchaseAmountTotal()) }}
                                        </td>
                                    </tr---->
                                </table>
                                <table v-else width="100%">
                                    <tr class="license-record-header">
                                        <td class="license-item-title" style="width: 30%" v-t="'message.item_license_basic'">
                                        </td>
                                        <td class="license-item-title" style="text-align:right;width: 20%;padding-right:25px" v-t="'message.item_purchase_current'">
                                        </td>
                                        <td class="license-item-title" style="text-align: right;width: 200px" v-t="'message.item_purchase_change'">
                                        </td>
                                        <td colspan="2" class="license-item-title" style="text-align: right;width: 15%;padding-right:10px" v-t="'message.item_purchase_renewal_amount'">
                                        </td>
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" class="license-item-title" style="text-align: right;width: 15%;padding-right:10px;" v-t="'message.item_purchase_additional_amount'">
                                        </td>
                                    </tr>
                                    <tr class="license-record-bottom">
                                        <td class="license-item-value">
                                            {{ getPurchasePlanName() }}
                                        </td>
                                        <td class="license-item-value" style="text-align: right;padding-right:25px">
                                            {{ Number(inputForm.license.numberLicense[0].pastMax).toLocaleString() }}
                                        </td>
                                        <td class="license-item-value" style="text-align: right">
                                            <el-input-number v-model="inputForm.license.numberLicense[0].newValue" :min="Math.max(inputForm.license.numberLicense[0].current, 1)" @change="changeNumberLicense(0)"></el-input-number>
                                        </td>
                                        <td colspan="2" class="license-item-value" style="text-align: right;padding-right:10px">
                                            {{ getDisplayAmountValue(Number(getNewAmountTotal())) }}
                                        </td>
                                        <td v-if="isPurchasePeriodYearly(contractInfo.purchasePeriodType)" class="license-item-value" style="text-align: right;padding-right:10px">
                                            {{ getDisplayAmountValue(Number(getPurchaseAmountTotal())) }}
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </el-form>
                    </div>
                    <hr class="dialog-hr">
                    <div v-if="isPurchasePeriodMonthly(contractInfo.purchasePeriodType)" class="license-item-value" style="text-align: center">
                        <table width="100%">
                            <tr>
                                <td width="50%">
                                    <span v-t="'message.item_purchase_current_amount'"/>
                                    <span class="total-amount">{{ getDisplayAmountValue(getCurrentAmountTotal()) }}</span>
                                    <span v-if="currencyYen" v-t="'message.unit_currency2'"/>
                                    <span v-else>USD</span>
                                </td>
                                <td width="50%">
                                    <span v-t="'message.item_purchase_next_amount'"/>
                                    <span class="total-amount">{{ getDisplayAmountValue(getNewAmountTotal()) }}</span>
                                    <span v-if="currencyYen" v-t="'message.unit_currency2'"/>
                                    <span v-else>USD</span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div v-else>
                        <table width="100%">
                            <tr>
                                <td width="50%">
                                    <el-collapse-transition>
                                        <div v-if="getPurchaseAmountTotal() > 0" class="contract-term">
                                            <span v-t="'message.item_purchase_additional_term'"/>
                                            <span class="term-date">{{ getContractTermString() }}</span>
                                        </div>
                                    </el-collapse-transition>
                                    <div class="purchase-amount">
                                        <span v-t="'message.item_purchase_additional_amount'"/>
                                        <span class="total-amount">{{ getDisplayAmountValue(getPurchaseAmountTotal()) }}</span>
                                        <span v-if="currencyYen" v-t="'message.unit_currency2'"/>
                                        <span v-else>USD</span>
                                    </div>
                                </td>
                                <td width="50%">
                                    <el-collapse-transition>
                                        <div v-if="getPurchaseAmountTotal() > 0" class="contract-term">
                                            <span v-t="'message.item_next_contract_term'"/>
                                            <span class="term-date">{{ getNextContractTermString() }}</span>
                                        </div>
                                    </el-collapse-transition>
                                    <div class="purchase-amount">
                                        <span v-t="'message.item_purchase_next_amount'"/>
                                        <span class="total-amount">{{ getDisplayAmountValue(getNewAmountTotal()) }}</span>
                                        <span v-if="currencyYen" v-t="'message.unit_currency2'"/>
                                        <span v-else>USD</span>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <hr class="dialog-hr">
                    <div class="dialog-button-field">
                        <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                        <el-button class="dialog-ok-button" @click="showConfirmPurchase()" :disabled="disableButton" v-t="'message.button_save'">
                        </el-button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "./PartnerServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import ConfirmLicense from './ConfirmLicense.vue';
import ConfirmLicenseForPlanPurchasing from './ConfirmLicenseForPlanPurchasing.vue';

export default {
    data() {
        return {
            remainingDate: 0,
            dayOfYear: 0,
            priceOfPlan: null,
            inputForm: {
                requestType: 4,
                license: [],
            },
            disableButton: true,
            confirmPurchase: false,
        };
    },
    methods: {
        showConfirmPurchase() {
            if (commonUtil.isExceedPaymentLimit(this, this.contractInfo.purchasePeriodType, this.getNewAmountTotal())) {
                return;
            }
            let licenseErrorMessage = commonUtil.purchaseLicenseConditionCheck(this.inputForm.license.numberLicense,this.inputForm.license.usageLicense,this.inputForm.license.chargedLicense,this.$i18n);
            if (licenseErrorMessage != "") {
                commonUtil.notifyMessage(this,"Warning",licenseErrorMessage);
                let obj = document.getElementById("dialog-body");
                obj.scrollTop = obj.scrollHeight;
                return;
            }
            this.confirmPurchase = true;
        },
        purchaseLicense() {
            if (this.contractInfo.planType == constants.LICENSE_PLAN_SEPARATE) {
                this.inputForm.requestType = constants.PURCHASE_REQUEST_MODIFY;
            } else {
                this.inputForm.requestType = constants.PURCHASE_REQUEST_MODIFY_PLAN;
            }
            this.$emit('save', this.inputForm)
        },

        // check number of license
        changeNumberLicense(index) {
            let license = this.inputForm.license.numberLicense[index];
            this.setNewAmount(license);
            switch(Number(license.type)) {
                case constants.LICENSE_USER:
                    if (license.newValue == 0) {
                        // this.disablePurchasingLicense(0); Commented because of "disablePurchasingLicense" not found error.
                        this.disableButton = true;
                    } else {
                        for (let checkLicense of this.inputForm.license.numberLicense) {
                            switch(Number(checkLicense.type)) {
                                case constants.LICENSE_SPEECH_TEXT :
                                case constants.LICENSE_TRANSLATION :
                                    checkLicense.disabled = false;
                                    if (checkLicense.newValue > license.newValue) {
                                        checkLicense.newValue = license.newValue;
                                        this.setNewAmount(checkLicense);
                                    }
                                    break;
                                case constants.LICENSE_CONFIG :
                                    if (checkLicense.newValue > 0) {
                                        checkLicense.newValue = license.newValue;
                                        this.setNewAmount(checkLicense);
                                    }
                                    break;
                                case constants.LICENSE_MAP_TALK :
                                    checkLicense.newValue = license.newValue;
                                    this.setNewAmount(checkLicense);
                                    break;
                            }
                        }
                        this.disableButton = false;
                    }
                    break;
                case constants.LICENSE_SPEECH_TEXT:
                    if (license.newValue == 0) {
                        this.disableRecurringLicense(constants.RECURRING_SPEECH_TEXT);
                        this.disableChargedLicense(constants.CHARGE_SPEECH_TEXT);
                        this.disableRecurringLicense(constants.RECURRING_TRANSLATION);
                        this.disableChargedLicense(constants.CHARGE_TRANSLATION);
                    } else {
                        this.enableRecurringLicense(constants.RECURRING_SPEECH_TEXT);
                        this.enableChargedLicense(constants.CHARGE_SPEECH_TEXT);
                    }
                    let translateLicense = this.inputForm.license.numberLicense.filter(function(item, index){
                        if (item.type == constants.LICENSE_TRANSLATION) return true;
                    });
                    if (license.newValue < translateLicense[0].newValue) {
                        translateLicense[0].newValue = license.newValue;
                        this.setNewAmount(translateLicense[0]);
                    }
                    this.disableButton = false;
                    break;
                case constants.LICENSE_TRANSLATION:
                    if (license.newValue  == 0) {
                        this.disableRecurringLicense(constants.RECURRING_TRANSLATION);
                        this.disableChargedLicense(constants.CHARGE_TRANSLATION);
                    } else {
                        this.enableRecurringLicense(constants.RECURRING_TRANSLATION);
                        this.enableChargedLicense(constants.CHARGE_TRANSLATION);
                    }
                    this.disableButton = false;
                    break;
            }
        },
        // check usage of license
        changeUsageLicense(index) {
            let license = this.inputForm.license.usageLicense[index];
            license.newValue = license.newCount * license.unit
            this.setNewAmount(license);
            this.disableButton = false;
        },
        // check usage of license
        changeChargedLicense(index) {
            let license = this.inputForm.license.chargedLicense[index];
            license.newValue = license.newCount * license.unit
            this.setNewAmount(license);
            this.disableButton = false;
        },
        enableRecurringLicense(licenseType) {
            for (let license of this.inputForm.license.usageLicense) {
                if (Number(license.type) == licenseType) {
                    license.disabled = false;
                    break;
                }
            }
        },
        enableChargedLicense(licenseType) {
            for (let license of this.inputForm.license.chargedLicense) {
                if (Number(license.type) == licenseType) {
                    license.disabled = false;
                    break;
                }
            }
        },
        disableRecurringLicense(licenseType) {
            for (let license of this.inputForm.license.usageLicense) {
                if (Number(license.type) == licenseType) {
                    // clear , disabled all option license if user license become to 0
                    license.newValue = 0;
                    license.newCount = 0;
                    license.purchaseAmount = 0;
                    license.newAmount = 0;
                    license.disabled = true;
                    break;
                }
            }
        },
        disableChargedLicense(licenseType) {
            for (let license of this.inputForm.license.chargedLicense) {
                if (Number(license.type) == licenseType) {
                    // clear , disabled all option license if user license become to 0
                    license.newValue = 0;
                    license.newCount = 0;
                    license.purchaseAmount = 0;
                    license.newAmount = 0;
                    license.disabled = true;
                    break;
                }
            }
        },
        setCurrentAmount(license) {
            switch(license.type) {
                case constants.LICENSE_USER:
                case constants.LICENSE_SPEECH_TEXT:
                case constants.LICENSE_TRANSLATION:
                case constants.LICENSE_CONFIG:
                case constants.LICENSE_MAP_TALK:
                case constants.LICENSE_ACCESS_LOG:
                    if (license.pastMax > 0) {
                        if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                            license.currentAmount = license.pastMax * license.monthlyPrice * (1 + this.appData.taxRate);
                        } else {
                            license.currentAmount = license.pastMax * license.yearlyPrice * 12 * (1 + this.appData.taxRate);
                        }
                    } else {
                        license.currentAmount = 0;
                    }
                    break;
                case constants.RECURRING_SPEECH_TEXT:
                case constants.RECURRING_TRANSLATION:
                    if (license.current > 0) {
                        license.currentAmount = (license.current / license.unit) * license.chargePrice * (1 + this.appData.taxRate);
                    } else {
                        license.currentAmount = 0;
                    }
                    break;
                case constants.CHARGE_SPEECH_TEXT:
                case constants.CHARGE_TRANSLATION:
                    if (license.orgValue > 0) {
                        license.currentAmount = (license.orgValue  / license.unit) * license.chargePrice * (1 + this.appData.taxRate);
                    } else {
                        license.currentAmount = 0;
                    }
                    break;
            }
        },
        setNewAmount(license) {
            switch(license.type) {
                case constants.LICENSE_USER:
                case constants.LICENSE_SPEECH_TEXT:
                case constants.LICENSE_TRANSLATION:
                case constants.LICENSE_CONFIG:
                case constants.LICENSE_MAP_TALK:
                case constants.LICENSE_ACCESS_LOG:
                    if (this.contractChangeOperation == null) {
                        if ((license.newValue -license.pastMax) > 0) {
                            if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                                license.newAmount = license.newValue * license.monthlyPrice * (1 + this.appData.taxRate);
                                license.newCurrentAmount = license.newAmount;
                            } else {
                                let amount = (license.newValue -license.pastMax) * license.yearlyPrice * 12 * (this.remainingDate/this.dayOfYear) * (1 + this.appData.taxRate);
                                if (this.currencyYen) {
                                    license.purchaseAmount = Math.ceil(amount);
                                } else {
                                    license.purchaseAmount = Math.ceil(amount*100) / 100;
                                }
                                license.newAmount = license.newValue * license.yearlyPrice * 12 * (1 + this.appData.taxRate);
                            }
                        } else {
                            if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                                license.newAmount = license.newValue * license.monthlyPrice * (1 + this.appData.taxRate);
                                license.newCurrentAmount = license.pastMax * license.monthlyPrice * (1 + this.appData.taxRate);
                            } else {
                                license.purchaseAmount = 0;
                                license.newAmount = license.newValue * license.yearlyPrice * 12 * (1 + this.appData.taxRate);
                            }
                        }
                    } else {
                        if ((license.newValue -license.pastMax) > 0) {
                            if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                                license.newAmount = license.newValue * license.yearlyPrice * 12 * (1 + this.appData.taxRate);
                                license.newCurrentAmount = license.newValue * license.monthlyPrice * (1 + this.appData.taxRate);
                            } else {
                                let purchaseAmount = (license.newValue -license.pastMax) * license.yearlyPrice * 12 * (this.remainingDate/this.dayOfYear) * (1 + this.appData.taxRate);
                                if (this.currencyYen) {
                                    license.purchaseAmount = Math.ceil(purchaseAmount);
                                } else {
                                    license.purchaseAmount = Math.ceil(purchaseAmount*100) / 100;
                                }
                                license.newAmount = license.newValue * license.monthlyPrice * (1 + this.appData.taxRate);
                            }
                        } else {
                            if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                                license.newAmount = license.newValue * license.yearlyPrice * 12 * (1 + this.appData.taxRate);
                                license.newCurrentAmount = license.pastMax * license.monthlyPrice * (1 + this.appData.taxRate);
                            } else {
                                license.purchaseAmount = 0;
                                license.newAmount = license.newValue * license.monthlyPrice * (1 + this.appData.taxRate);
                            }
                        }
                    }
                    break;
                case constants.RECURRING_SPEECH_TEXT:
                case constants.RECURRING_TRANSLATION:
                    if (license.newValue > 0) {
                        license.newAmount = license.newCount * license.chargePrice * (1 + this.appData.taxRate);
                    } else {
                        license.newAmount = 0;
                    }
                    // recurring fee was charged at nextFlushDate except first purchase on yearly contract.
                    if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_YEARLY) {
                        if (license.orgValue == 0) {
                            license.purchaseAmount = license.newCount * license.chargePrice * (1 + this.appData.taxRate);
                        } else {
                            license.purchaseAmount = 0;
                        }
                    } else {
                        license.purchaseAmount = 0;
                    }
                    license.newCurrentAmount = license.purchaseAmount * (1 + this.appData.taxRate);
                    break;
                case constants.CHARGE_SPEECH_TEXT:
                case constants.CHARGE_TRANSLATION:
                    if (license.newValue > 0) {
                        license.newAmount = license.newCount * license.chargePrice * (1 + this.appData.taxRate);
                        if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                            license.purchaseAmount = 0;
                        } else {
                            license.purchaseAmount = license.newCount * license.chargePrice * (1 + this.appData.taxRate);
                        }
                    } else {
                        license.newAmount = 0;
                        license.purchaseAmount = 0;
                    }
                    license.newCurrentAmount = license.currentAmount + license.newAmount;
                    break;
            }
        },
        getCurrentAmountTotal() {
            let total = 0;
            if (this.contractInfo.planType == constants.LICENSE_PLAN_SEPARATE) {
                if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                    for (let license of this.inputForm.license.numberLicense) {
                        if (license.pastMax >= license.newValue) {
                            total += (license.pastMax * license.monthlyPrice) * (1 + this.appData.taxRate);
                        } else {
                            total += (license.newValue * license.monthlyPrice) * (1 + this.appData.taxRate);
                        }
                    }
                } else {
                    for (let license of this.inputForm.license.numberLicense) {
                        total += license.currentAmount;
                    }
                }

                for (let license of this.inputForm.license.usageLicense) {
                    total += license.currentAmount;
                }

                for (let license of this.inputForm.license.chargedLicense) {
                    total += license.newAmount;
                    total += license.currentAmount;
                }
            } else {
                let license = this.inputForm.license.numberLicense[0];
                let billableLicense;
                if (license.pastMax >= license.newValue) {
                    billableLicense = license.pastMax;
                } else {
                    billableLicense = license.newValue;
                }
                if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                    total += (billableLicense * this.priceOfPlan.monthPrice);
                } else {
                    total += (billableLicense * this.priceOfPlan.yearPrice * 12);
                }
                total += (total * this.appData.taxRate)
            }

            return Number(total);  // first version not support usage license.
        },
        getPurchaseAmountTotal() {
            let totalAmount = 0;
            if (this.contractInfo.planType == constants.LICENSE_PLAN_SEPARATE) {
                for (let license of this.inputForm.license.numberLicense) {
                    totalAmount  += license.purchaseAmount;
                }

                if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                    for (let license of this.inputForm.license.usageLicense) {
                        totalAmount  += license.purchaseAmount;
                    }
                }

                for (let license of this.inputForm.license.chargedLicense) {
                    totalAmount  += license.purchaseAmount;
                }
            } else {
                let licenseInfo = this.inputForm.license.numberLicense[0];
                if (licenseInfo.newValue > licenseInfo.pastMax) {
                    let purchaseLicenseCount = licenseInfo.newValue - licenseInfo.pastMax
                    if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                        totalAmount  = purchaseLicenseCount * this.priceOfPlan.monthPrice;
                    } else {
                        totalAmount = Number(purchaseLicenseCount * this.priceOfPlan.yearPrice * 12 * commonUtil.getBillableRate(this.contractInfo.nextFlushDatetime));
                    }
                    totalAmount += (totalAmount * this.appData.taxRate)
                    if (this.currencyYen) {
                        return Math.ceil(totalAmount);
                    } else {
                        return Math.ceil(totalAmount*100) / 100;
                    }
                }
            }

            return Number(totalAmount);  // first version not support usage license.
        },
        getNewAmountTotal() {
            let totalAmount = 0;
            if (this.contractInfo.planType == constants.LICENSE_PLAN_SEPARATE) {
                for (let license of this.inputForm.license.numberLicense) {
                    totalAmount += license.newAmount;
                }

                for (let license of this.inputForm.license.usageLicense) {
                    totalAmount += license.newAmount;
                }
            } else {
                if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY) {
                    totalAmount += (this.inputForm.license.numberLicense[0].newValue * this.priceOfPlan.monthPrice);
                } else {
                    totalAmount += (this.inputForm.license.numberLicense[0].newValue * this.priceOfPlan.yearPrice * 12);
                }
                totalAmount += (totalAmount * this.appData.taxRate);
            }
            return Number(totalAmount);  // first version not support usage license.
        },
        getPurchasePeriodTypeName(purchasePeriodType) {
            return commonUtil.getPurchasePeriodTypeName(this.$i18n, purchasePeriodType);
        },
        getPurchasePlanName() {
            return commonUtil.getPlanName(this.contractInfo.planType);
        },
        getDisplayDateTime(datetime) {
            return new Date(datetime).toLocaleString();
        },
        getContractChangeNotice() {
            return commonUtil.getContractChangeNotice(this.$i18n, this.contractInfo);
        },
        isPurchasePeriodMonthly(purchasePeriodType) {
            return (purchasePeriodType == constants.PURCHASE_PERIOD_MONTHLY);
        },
        isPurchasePeriodYearly(purchasePeriodType) {
            return (purchasePeriodType == constants.PURCHASE_PERIOD_YEARLY);
        },
        isActiveContract(state) {
            return (!(state == constants.CONTRACT_TERMINATE));
        },
        getContractTermString() {
            let nextFlushDate = new Date(this.contractInfo.nextFlushDatetime);
            let today = new Date();
            return today.toLocaleDateString() + "～" + nextFlushDate.toLocaleDateString();
        },
        getNextContractTermString() {
            let nextFlushDate = new Date(this.contractInfo.nextFlushDatetime);
            let nextContractEndDate;
            if (this.contractChangeOperation == null) {
                nextContractEndDate = new Date(nextFlushDate.getFullYear()+1, nextFlushDate.getMonth(), nextFlushDate.getDate());
            } else {
                nextContractEndDate = new Date(nextFlushDate.getFullYear(), nextFlushDate.getMonth()+1, nextFlushDate.getDate());
            }
            return nextFlushDate.toLocaleDateString() + "～" + nextContractEndDate.toLocaleDateString();
        },
        getUnitName(licenseType) {
            return commonUtil.getUnitName(this.$i18n, licenseType);
        },
        getDisplayAmountValue(amount) {
            if (this.currencyYen) {
                return amount.toLocaleString();
            } else {
                return amount.toFixed(2).toLocaleString();
            }
        },
        isNeedExpandBody() {
            if (this.contractInfo.purchasePeriodType == constants.PURCHASE_PERIOD_YEARLY) {
                if (this.getPurchaseAmountTotal() > 0) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }
    },
    watch: {
        confirmPurchase(value) {
            let obj = document.getElementById("dialog-body");
            obj.scrollTop = 0;
        }
    },
    computed: {
    },
    created: function() {
        this.inputForm.license = this.licenseInfo;

        let now = new Date();
        this.inputForm.trialExpireDate = new Date(now.getFullYear(), now.getMonth() + 1, now.getDate());

        let flushDate = new Date(this.contractInfo.nextFlushDatetime);
        this.remainingDate = Math.floor((flushDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24)) + 1;
        let startDate = new Date(this.contractInfo.nextFlushDatetime);
        startDate.setYear(startDate.getYear() + 1900 - 1);
        this.dayOfYear  = Math.floor((flushDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24));

        for (let license of this.licenseInfo.numberLicense) {
            this.setCurrentAmount(license);
            this.setNewAmount(license);
        }
        for (let license of this.licenseInfo.usageLicense) {
            this.setCurrentAmount(license);
            this.setNewAmount(license);
        }
        for (let license of this.licenseInfo.chargedLicense) {
            this.setCurrentAmount(license);
            this.setNewAmount(license);
        }

        if (this.contractInfo.planType != constants.LICENSE_PLAN_SEPARATE) {
            for (let price of this.priceList) {
                if (price.type == this.contractInfo.planType) {
                    this.priceOfPlan = price;
                    break;
                }
            }
        }

    },
    components: {
        confirmlicense: ConfirmLicense,
        ConfirmLicenseForPlanPurchasing: ConfirmLicenseForPlanPurchasing
    },
    props: [ 'appData' , 'licenseInfo' , 'contractInfo' , 'contractChangeOperation' , 'disablePurchasingOption' , 'currencyYen' , 'priceList' ]
}
</script scoped>
<style scoped>
.contract-change-notice {
    padding-left: 10px;
    color: #d55169;
    font-size: 14px;
    font-weight: normal;
}
.confirm-item-table > table {
    border-collapse: collapse;
    border-spacing: 0px;
}
.date-picker > .el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 180px!important;
}
.dialog-form-item-price >>> .el-input__inner {
    text-align: right;
}

.dialog-description {
    padding-bottom: 20px;
}
.dialog-body {
    height: calc(90vh - 210px);
    overflow: auto;
}
.dialog-body-year {
    height: calc(90vh - 260px);
    overflow: auto;
}
.dialog-body-confirm {
    height: calc(90vh - 5px);
}
.inputform {
    padding: 20px;
}

.icon-help {
    height: 14px;
}

.license-item-value >>> .el-input-number {
    width: 170px;
}

.term-date {
    font-size: 14px;
}

.purchase-amount {
    text-align: center;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 20px;
    font-size: 14px;
}

.contract-term {
    text-align: center;
    color:#848991;
    padding-top: 24px;
    padding-left: 20px;
    font-size: 14px;
}

</style scoped>

